import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

/**
 *
 * @param {Object} props - Component props.
 * @param {String} props.featureName - Feature's keyName  on which check the activation.
 * @param {ReactNode} props.children - Children to show/hide depending on feature value.
 * @param {ReactNode} props.childReplacement - (Optional). Child to show instead of children when feature value is "false".
 * @returns {React.JSX.Element}
 */

const FeatureWrapper = function FeatureWrapper({
  featureName = '',
  children = null,
  childReplacement = null,
}) {
  const { databeasy } = window || {};
  return (
    <Fragment key="feature-flag">
      {Object.hasOwn(databeasy, featureName) &&
      (databeasy[featureName] === 'true' ||
        databeasy[featureName] === 'True' ||
        databeasy[featureName] === true)
        ? children
        : childReplacement}
    </Fragment>
  );
};

FeatureWrapper.propTypes = {
  featureName: PropTypes.string,
  children: PropTypes.node,
  childReplacement: PropTypes.node,
};

export default FeatureWrapper;
